
import Banner from "../components/banner/banner"
import SideMenu from "../components/sideMenu/sideMenu"
import YearAnniversary from "../components/aboutUniten/yearAnniversary"
import Putrajaya from "../components/aboutUniten/putrajaya"
import Kshas from "../components/aboutUniten/kshas"
import Academics from "../components/aboutUniten/academics"
import HallOfFrame from "../components/aboutUniten/hallOfFrame"
import History from "../components/aboutUniten/history"
import Mission from "../components/aboutUniten/mission"
import Others from "../components/aboutUniten/others"
import PresentAndFuture from "../components/aboutUniten/presentAndFuture"
import WhyUniten from "../components/aboutUniten/whyUniten"
import Uiac from "../components/aboutUniten/uiac"
import AboutUniten from "../components/aboutUniten/aboutUniten"
import SongAndIcon from "../components/aboutUniten/songAndIcon"
import AnimatedPage from "../components/animatedPage"
import { useSelector, useDispatch } from "react-redux"
import { useEffect } from 'react';
import { fetchAboutUnitenData } from "../redux/slice/aboutUnitenPage"
import { retrunAssets } from './../utils/getAssets';

const About = () => {


    const state = useSelector(state => state.aboutUniten)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data === null) {
            dispatch(fetchAboutUnitenData("about-uniten"))
        }
    }, [state, dispatch])


    const aboutUniten = state?.data?.properties
    const text = aboutUniten?.title
    const bg = aboutUniten?.backgroundImage != null ? retrunAssets(aboutUniten?.backgroundImage[0]?.url) : ""
    const content = aboutUniten?.content
    const list = content != null ? [
        {
            title: "About Uniten",
            subItems: [
                {
                    index: 0,
                    name: content[0]?.name,

                },
                {
                    index: 1,
                    name: content[1]?.name,

                },
                {
                    index: 2,
                    name: content[2]?.name,

                },
                {
                    index: 3,
                    name: content[3]?.name,

                },
                {
                    index: 4,
                    name: content[4]?.name,

                },
                {
                    index: 5,
                    name: content[5]?.name,

                },
                {
                    index: 6,
                    name: content[6]?.name,

                },

            ]
        },
        {
            index: 7,
            title: content[7]?.name,

        },
        {
            index: 8,
            title: content[8]?.name,

        },
        {
            index: 9,
            title: content[9]?.name,

        },
        {
            title: "Campuses",
            subItems: [
                {
                    index: 10,
                    name: content[10]?.name,
                },
                {
                    index: 11,
                    name: content[11]?.name
                },

            ]
        },
        // {
        //     index: 12,
        //     title: content[12]?.name

        // },

    ]
        : []
    const contents = content != null ? [
        <AboutUniten key="0" />,
        <History key="1" />,
        <Mission key="2" />,
        <SongAndIcon key="3" />,
        // <YearAnniversary key="4" />,
        <PresentAndFuture key="5" />,
        <Others key="6" />,
        <WhyUniten key="7" />,
        <HallOfFrame key="8" />,
        <Academics key="9" />,
        <Putrajaya key="10" />,
        <Kshas key="11" />,
        <Uiac key="12" />,

    ] : []
    return (
        <AnimatedPage>
            {/* <ScrollToTop /> */}
            <Banner text={text} bg={bg} />
            <div className="flex justify-center bg-white p-4 md:py-8 w-full">
                <div className="w-full flex flex-col gap-5 lg:px-16  ">
                    <SideMenu list={list} contents={contents} />

                    
                </div>
            </div>
        </AnimatedPage>
    )
}

export default About